import t_19_2076_colorized from './t_19_2076_colorized.png'
import t_19_2076 from './t_19_2076.png'

export default [
  t_19_2076_colorized,
  t_19_2076
]
